import React from 'react';
import { Route, Routes, BrowserRouter as Router, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import ScrollToTop from './components/ScrollToTop.jsx';
import HiperpanLandingPage from './pages/HiperpanLandingPage.jsx';
import ThankYouPage from './pages/ThankYouPage.jsx';
import ErrorBoundary from './components/ErrorBoundary.jsx';
import { EditProvider } from './contexts/EditContext.jsx';

function App() {
  return (
    <ErrorBoundary>
      <EditProvider>
        <Router>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HiperpanLandingPage />} />
            
            {/* Canonical Thank You Page */}
            <Route path="/obrigado" element={<ThankYouPage />} />
            
            {/* Alias to support /thank-you routing requests */}
            <Route path="/thank-you" element={<Navigate to="/obrigado" replace />} />
            
            {/* Catch-all 404 handler redirecting to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors closeButton />
        </Router>
      </EditProvider>
    </ErrorBoundary>
  );
}

export default App;